import { PricesMode } from '../../redux/config'

export type PriceLabelProps = {
  pricesMode: PricesMode
  label: string
  netLabel: string
}

export const PriceLabel = ({ pricesMode, label, netLabel }: PriceLabelProps) => {
  switch (pricesMode) {
    case PricesMode.WithTaxInfo:
      return netLabel
    default:
      return label
  }
}
